<template >
    <div class="bibliometric-analysis">
        <div class="analysis-banner" > 
            <div class="banner-search">
                <!-- <div class="search-tit "> 分析池检索 </div> -->
                <div class="search-cont"> 
                    <el-row  type="flex" class="row-bg" justify="space-between">
                        <el-col :span='4'>
                            <el-select  v-model="searchData.fieldName" placeholder="请选择">
                                <el-option
                                    v-for="item in searchInfoList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value" >
                                </el-option>
                            </el-select>
                        </el-col> 
                        <el-col  :span='16'> 
                            <el-input  placeholder="请输入内容"  v-model="searchData.keyword" clearable></el-input>
                        </el-col>
                        <el-col  :span='4' class="search-btn">
                            <el-button type="primary" @click="getList(1)" icon="el-icon-search">
                                分析池检索
                            </el-button>
                            <!-- <div class="ai-btn" @click="getList(1)">
                                <span class="icon search-icon"></span>
                                <span class="search-txt" >分析池检索</span> 
                            </div> -->
                        </el-col>
                    </el-row>
                </div>  
            </div> 
        </div>
        <div class="page-cont"> 
            <div class="page-top"> 
                
                <div class="top-right">   
                    <el-upload
                        class="upload-file"
                        accept
                        action
                        :limit="1"
                        :show-file-list="false" 
                        :before-remove="fileBeforeRemove"
                        :on-remove="fileHandleRemove"
                        :on-preview="fileHandlePreview" 
                        :http-request="uploadExcel">
                        <el-button type="success" plain > 上传文献</el-button> 
                    </el-upload>
                    <el-button type="primary" plain  @click="down_flie"> 下载模板</el-button> 
                    <el-button type="warning" plain :disabled='tableList.length==0' @click="batch_delete('batch')" :loading="isBatchDelete"> 批量删除</el-button>
                    <el-button type="danger" plain :disabled='tableList.length==0' :loading="isRemove" @click="removeAll">一键清空</el-button>     
                 
                    <p class="change-num" v-if='chooseNum!=0'>已选择<span>{{ chooseNum }}</span>条数据</p>  
                     
                </div>
                <div class="analysis-btn" @click="batch_analysis" >
                    文献计量分析 <i class="el-icon-d-arrow-right"></i> 
                    <!-- <span  @click="backSearch">检索列表 </span> 
                    <span class="tab-active"> 分析池列表 （{{analysisNum}}） </span>  -->

                    <!-- 点击“文献计量分析”后，进入分析结果页。 -->
                    <!-- <el-button type="primary" plain :disabled='tableList.length==0' @click="batch_analysis">文献计量分析</el-button> -->
                </div> 
            </div>
            <div class="bibliometric-cont"  >
                <div class="cont-right">   
                    <div class="table-list" v-loading="tableLoad">
                        <el-table
                            ref='tableList'
                            :header-cell-style="{background:'#396de7',color:'#fff'}" 
                            :data="tableList"
                            :row-key="(row) => { return row.id }" 
                            @selection-change="selectChange"
                            border>
                                <el-table-column v-removeAriaHidden type="selection" width="55" :reserve-selection="true"></el-table-column>
                                <el-table-column
                                    label="中文题名"  
                                    prop="cnTitle"  
                                    width='400'
                                >
                                    <template slot-scope="scope">
                                        <p class="txt-overflow1" v-html="scope.row.cnTitle"></p>
                                    </template>
                                </el-table-column> 
                                <el-table-column 
                                    prop="author"
                                    label="作者" 
                                    width='340'>
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :disabled='scope.row.author.length<15' :content="scope.row.author" placement="bottom-start">
                                            <p class="txt-overflow1" v-html="scope.row.author"></p>
                                        </el-tooltip> 
                                    </template>
                                </el-table-column>
                                <el-table-column 
                                    prop="source"
                                    label="来源" >
                                    <template slot-scope="scope">
                                        <p class="txt-overflow1" v-html="scope.row.source"></p>
                                    </template>
                                </el-table-column>
                                <el-table-column 
                                    prop="year"
                                    width="100"
                                    label="发表年份">
                                    <template slot-scope="scope">
                                        <p v-html="scope.row.year"></p> 
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="操作" 
                                    show-overflow-tooltip
                                    width="140"
                                >
                                    <template slot-scope="scope">
                                        <el-button class="table-column-btn" type="text"  @click="toDetails(scope.row)">查看详情</el-button>
                                        <el-button class="table-column-btn" type="text" @click="batch_delete('alone',scope.row)">删除</el-button>    
                                    </template>
                                </el-table-column>
                        </el-table>
                        <el-pagination 
                            class="page-wrap"  
                            @current-change="changePage" 
                            @size-change="sizeChange"
                            background
                            :current-page="pageInfo.pageNum" 
                            :page-count="pageInfo.pageTotal" 
                            :page-size="pageInfo.pageSize"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            :total="pageInfo.total"
                            layout="total, sizes, prev, pager, next, jumper" >
                        </el-pagination>
                    </div> 
                </div>
            </div> 
        </div>
        <div id='atlasId'>
            <atlasResult ref='bibliometric_atlas' v-if='isAtlas' :keyWord='searchData.keyWord'></atlasResult>
        </div>
    </div>
</template>
<script>
import {mapState,mapMutations,mapActions} from 'vuex'
import {analysisPage,bibliometricsDeleteAnalysisPoolData,removeAllAnalysisPoolData,bibliometricsUpload} from '../../io/api.js'
import atlasResult from './atlas_result.vue'
export default {
    components:{
        atlasResult,
    },
    data() {
        return {
            tableLoad:false, 
            isBatchDelete:false,
            isRemove:false,
            tableList:[],
            isAtlas:false,
            // keyWord:[],
            // analysisNum:0,
            chooseNum:0,
            searchData:{
                keyword:'',
                fieldName:'cnTitle',
            },
            batchDetails:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },  
            searchInfoList:[ 
                {label:'题名',value:'cnTitle'},
                {label:'关键词',value:'keyWord'}, 
                {label:'作者',value:'author'},
                {label:'单位',value:'authorAffiliation'},
                {label:'分类号',value:'classNum'}, 
                {label:'时间',value:'year'},  
            ],
            fileList:[],
        }
    },
    computed: {
        ...mapState({
            analysisNum:state=>state.bibliometric.analysisNum,
        }), 
        batchIdsAnalysis:{
            get(){return this.$store.state.bibliometric.batchIdsAnalysis},
            set(val){this.$store.state.bibliometric.batchIdsAnalysis=val}
        },
    },
    mounted(){
        this.getInit(1)
    },  
    methods:{
        ...mapActions(['getAnalysisNum']),
        getInit(num){
            this.getAnalysisNum();
            this.getList(num);
        },
        getList(num){
            if(num){
                this.pageInfo.pageNum=num
            }
            let params={
                page: this.pageInfo.pageNum,
                limit:this.pageInfo.pageSize,
                ...this.searchData 
            } 
            this.tableLoad=true;
            analysisPage(params).then(res=>{
                let {data,code,msg}=res.data;
                if(code==0){
                    this.tableList=data.list||[];
                    this.pageInfo.total=data.totalCount||0;
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.tableLoad=false;
            })
        },
        selectChange(val){ 
            if(this.batchIdsAnalysis.length!=this.pageInfo.total){
                this.batchDetails=val;
                this.batchIdsAnalysis=[]
                this.batchDetails.forEach(item => {
                    this.batchIdsAnalysis.push(item.id)
                });
                this.chooseNum=this.batchIdsAnalysis.length;
            }
              
        }, 
        //批量删除
        batch_delete(type,row){ 
            let arr=[];
            if(type=='batch'){ 
                if(this.batchDetails.length==0){
                    this.$message.error('请选择删除数据！');
                    return
                }else{
                    this.isBatchDelete=true;
                    arr=this.batchIdsAnalysis;
                }
            }else{
                arr.push(row.id)
            }
            
            bibliometricsDeleteAnalysisPoolData(arr).then(res=>{
                let {code,data,msg} = res.data;
                if(code==0){
                    this.$message.success('批量删除成功');
                    this.batchIdsAnalysis=[];
                    this.batchDetails=[];
                    this.$refs.tableList.clearSelection();
                    this.getInit(); 
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.isBatchDelete=false;
            })
        },
        //文献计量
        batch_analysis(type){ 
            console.log(this.analysisNum)
            if(this.analysisNum>=2000){
                this.$message.warning('数据过多，请筛选后进行分析！');
                return
            }
            this.isAtlas=true;
            this.$nextTick(() => {
                if (this.isAtlas) {
                    const toElement = document.getElementById('atlasId');
                    if (toElement) {
                        toElement.scrollIntoView(true);
                    }
                }
                this.$refs.bibliometric_atlas.getData();
            });  
        }, 

        //一键清空
        removeAll(){
            this.isRemove=true;
            removeAllAnalysisPoolData().then(res=>{
                let {code,msg} =res.data;
                if(code==0){
                    this.$message.success('数据清空成功');
                    this.getInit(1)
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.isRemove=false;
            })
        },
        //下载模版
        down_flie(){
            window.open('https://www.tcmkb.cn/knowservePlatform/fujian/templates/文献计量分析池导入模板.xlsx')
        },
        //上传文献
        uploadExcel(param){
            let formData = new FormData();
            formData.append("file", param.file);
            bibliometricsUpload(formData).then((res) => { 
                let {code,data,msg} = res.data;
                if(code==0){
                    this.$message.success(data ||'上传成功');
                    this.getInit(1); 
                }else{
                    this.$message.error(msg ||'请求失败～');
                }
            });
        },
        fileHandleExceed(files, fileList) {
            this.$message.warning(`限制上传 3 个文件`)
            // this.$message.warning(`限制上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        fileBeforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        fileHandlePreview(file) {
            
            // this.attachment.splice(this.directoryUrl.indexOf(url),1); 
        },
        fileHandleRemove(file, fileList) {
            let name = file.name || file.response.name;
            this.upFileList.forEach((item,index)=>{
                if(item.yuan==name){
                    this.upFileList.splice(index,1); 
                }
            })
        },
        backSearch(){
            let url= this.$router.resolve({
                path:'bibliometric',
                query:{ 
                    changeflag:2
                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} ) 
        },
        toDetails(row){
            let path='bibliometricDetails'
            if(this.$route.path === '/bibliometricAnalysisOut'){ 
                path='bibliometricDetailsOut'
            }
            let url= this.$router.resolve({
                path,
                query:{
                    id:row.id,
                    sourceType:'analysis',
                    changeflag:2
                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} ) 
        },
        // 切换分页
        changePage(num) {
            this.pageInfo.pageNum=num;
            this.getList()
        },
        // 
        sizeChange(val){
            this.pageInfo.pageSize=val;
            this.getList(); 
        },
    }
}
</script>
<style lang="less" scoped>
@import url('./index.less');    
.bibliometric-analysis{
    width: 100%;
    min-width: 1200px;
    padding-bottom: 40px; 
    .analysis-banner{
        padding-top: 40px; 
        min-width: 1200px;
        .banner-search {   
            padding-bottom: 0;
            .row-bg{
                width:980px;
                margin: 0 auto; 
                align-items:center;
            }
            .search-btn{
                width: 150px; 
                margin: 0; 
            }
            .search-cont{
                margin-bottom: 0;
            }
        }
    }
    .analysis-btn{
        color: #396de7;
        // background-color: #ffffff;
        font-size: 18px;
        width: 135px;
        height: 46px;
        line-height: 46px;
        border-radius: 12px; 
        font-weight: bold;
        cursor: pointer; 
        text-align: center;
    } 
    .upload-file{
        margin-right:10px;
    }
}  
</style>